import {Box, Flex, Text} from 'exsportia-components'
import React, {FC, useMemo} from 'react'

import {useBookingCancelDetails} from '../../../api/booking/get-booking-cancel-details-data'
import {useVenue} from '../../../api/venue/hooks'
import {CurrenciesEnum} from '../../../types/currencies'
import {Button} from '../../../ui/components/button/button'
import {useLocale} from '../../../utils/i18n'
import {useModalActions} from '../../../utils/modals'
import {CancelInfoComponent} from './cancel-info-component'

export type CancelBookingConfirmationModalProps = {
  bookingId: string
  isLoggedIn: boolean
  onCancelConfirm: () => void
}

export const CancelBookingConfirmationModal: FC<CancelBookingConfirmationModalProps> = ({
  bookingId,
  onCancelConfirm,
  isLoggedIn,
}) => {
  const {data: cancelDetails, isLoading} = useBookingCancelDetails(bookingId)
  const {data: venue} = useVenue()
  const {closeModal} = useModalActions()
  const currency = venue?.currency || CurrenciesEnum.THB
  const {contactToVenue, isAbleToCancel, isBookingOwner} = cancelDetails || {}
  const {l} = useLocale()

  const cancelDetailsText = useMemo(() => {
    if (!isLoading && !isAbleToCancel) {
      if (contactToVenue) {
        return l('contactVenueToCancel', {caseAction: 'capitalize'})
      } else if (!isLoggedIn) {
        return l('loginToCancel', {caseAction: 'capitalize'})
      } else if (!isBookingOwner) {
        return l('thisAccCantBeUsedToCancel', {caseAction: 'capitalize'})
        // eslint-disable-next-line
      } else {
        return l('thisBookingCantBeCancelled', {caseAction: 'capitalize'})
      }
    }
  }, [contactToVenue, isAbleToCancel, isBookingOwner, isLoggedIn, isLoading, l])

  return (
    <>
      <Box width='100%' my='16px'>
        {cancelDetailsText && <Text text={cancelDetailsText}/>}
        <CancelInfoComponent isLoading={isLoading} cancelDetails={cancelDetails} currency={currency}/>
      </Box>
      <Flex justifyContent={'flex-end'} py={'24px'}>
        <Box>
          <Button type='flat' onClick={closeModal}>
            {l('back', {caseAction: 'capitalize'})}
          </Button>
        </Box>
        <Box ml={'16px'}>
          <Button disabled={isLoading} type='primary' onClick={isAbleToCancel ? onCancelConfirm : closeModal}>
            {l('confirm', {caseAction: 'capitalize'})}
          </Button>
        </Box>
      </Flex>
    </>
  )
}


